import { render } from "./AgreementPersonalDataView.vue?vue&type=template&id=c3ab817e"
import script from "./AgreementPersonalDataView.vue?vue&type=script&lang=js"
export * from "./AgreementPersonalDataView.vue?vue&type=script&lang=js"

import "./AgreementPersonalDataView.vue?vue&type=style&index=0&id=c3ab817e&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__